/*
 * Copyright (c) 2023-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import PropTypes from 'prop-types';
import DisplayIcon from "../Icons/DisplayIcon.jsx";

function EmptyStateBig(props) {
    return (
        <div
            className="w-full  flex justify-center items-center" style={{height: "70vh"}}>
            <div className="space-y-1 text-center">
                <DisplayIcon iconName={props.iconName} className={"mx-auto h-12 w-12 text-gray-400"}/>
                {/*<IoTelescopeOutline className="mx-auto h-12 w-12 text-gray-400"/>*/}
                <div className="flex text-sm text-gray-600">
                    <div className="pl-1">{props.text} </div>
                </div>
            </div>
        </div>
    );
}

EmptyStateBig.propTypes = {
    text: PropTypes.any,
    iconName: PropTypes.string
};
EmptyStateBig.defaultProps = {
    iconName: "IoTelescopeOutline"

}

export default EmptyStateBig;